import script from "./maintenance-request-list-summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./maintenance-request-list-summary.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__